import script from "./HomeServiceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServiceComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeServiceComponent.vue?vue&type=style&index=0&id=b45b5a48&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-morula\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b45b5a48"]])

export default __exports__